import { render, staticRenderFns } from "./BondControlMassiveList.vue?vue&type=template&id=2837cd4a"
import script from "./BondControlMassiveList.vue?vue&type=script&lang=ts"
export * from "./BondControlMassiveList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports